import React from 'react';
import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
import useInfinityScroll from 'hooks/useInfinityScroll';
import { AlternativeTable } from 'components';
import useStatsList from 'hooks/useStatsList';
import { columns, EventStatsType } from './columns';
import { Props } from '../types';

const statsPath = 'statsPerEvent';
const itemsKey = 'eventStatistics';

const EventStats = ({ employeeId }: Props) => {
  const { items, total, isLoading, handleLoadMore } = useStatsList({
    employeeId,
    itemsKey,
    itemsPerPage: 10,
    statsPath
  });

  const table = useReactTable({
    data: items as EventStatsType[],
    columns,
    getCoreRowModel: getCoreRowModel()
  });

  const { containerRef, fetchMoreOnBottomReached } = useInfinityScroll({
    onLoadMore: handleLoadMore,
    totalDBRowCount: total,
    totalFetched: items.length,
    isFetching: isLoading
  });

  return (
    <AlternativeTable
      config={table}
      ref={containerRef}
      fetchMoreOnBottomReached={fetchMoreOnBottomReached}
      isLoading={isLoading}
    />
  );
};

export default EventStats;
